module.exports = __webpack_public_path__ + "media/images/payment-1-2c2d85c58b63f5a4e36eab99d0a8eda2.png";